import { useEffect, useState } from 'react'
import HeroSection from '../components/sections/HeroSection'
import StatsStrip from '../components/sections/StatsStrip'
import ClientCarousel from '../components/sections/ClientCarousel'
import ServicesGrid from '../components/sections/ServicesGrid'
import PortfolioGrid from '../components/sections/PortfolioGrid'
import TestimonialCarousel from '../components/sections/TestimonialCarousel'
import TeamSection from '../components/sections/TeamSection'
import CTASection from '../components/sections/CTASection'
import LoadingSpinner from '../components/ui/LoadingSpinner'

export default function Home() {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 100)
    return () => clearTimeout(timer)
  }, [])

  if (!ready) return <LoadingSpinner text="Loading..." />

  return (
    <>
      <main>
        <HeroSection />
        <StatsStrip />
        <ClientCarousel />
        <ServicesGrid />
        <PortfolioGrid />
        <TestimonialCarousel />
        <TeamSection />
        <CTASection />
      </main>
    </>
  )
}
